import Vue from "vue";
import {
  ColorPicker,
  Button,
  Form,
  FormItem,
  Input,
  Table,
  TableColumn,
  // Descriptions,
  // DescriptionsItem,
  Container,
  Header,
  Aside,
  Main,
  Message,
  Menu,
  Submenu,
  MenuItemGroup,
  MenuItem,
  // Footer,
  Breadcrumb,
  BreadcrumbItem,
  Card,
  Upload,
  Dialog,
  Row,
  Col,
  DatePicker,
  TimePicker,
  Select,
  Option,
  // Badge,
  CheckboxGroup,
  Checkbox,
  Drawer,
  MessageBox,
  Switch,
  Tabs,
  TabPane,
  Divider,
  Tree,
  Tooltip,
  Carousel,
  CarouselItem,
  Image,
  Popover,
  Empty,
  Step,
  Steps,
  RadioGroup,
  Radio,
  RadioButton,
  Pagination,
  Cascader,
  Scrollbar,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  Loading
} from "element-ui";

Vue.use(Button);
Vue.use(Form);
Vue.use(FormItem);
Vue.use(Input);
Vue.use(Table);
Vue.use(TableColumn);
Vue.use(ColorPicker);
// Vue.use(Descriptions)
// Vue.use(DescriptionsItem)
Vue.use(Container);
Vue.use(Header);
Vue.use(Aside);
Vue.use(Main);
Vue.use(Menu);
Vue.use(Submenu);
Vue.use(MenuItemGroup);
Vue.use(MenuItem);
// Vue.use(Footer)
Vue.use(Breadcrumb);
Vue.use(BreadcrumbItem);
Vue.use(Card);
Vue.use(Upload);
Vue.use(Dialog);
Vue.use(Row);
Vue.use(Col);
Vue.use(DatePicker);
Vue.use(Select);
Vue.use(Option);
// Vue.use(Badge)
Vue.use(CheckboxGroup);
Vue.use(Checkbox);
Vue.use(Drawer);
Vue.use(Switch);
Vue.use(Tabs);
Vue.use(TabPane);
Vue.use(Divider);
Vue.use(Tree);
Vue.use(Tooltip);
Vue.use(Carousel);
Vue.use(CarouselItem);
Vue.use(Image);
Vue.use(Popover);
Vue.use(Empty);
Vue.use(Step);
Vue.use(Steps);
Vue.use(RadioGroup);
Vue.use(Radio);
Vue.use(RadioButton);
Vue.use(Pagination);
Vue.use(Cascader);
Vue.use(TimePicker);
Vue.use(Scrollbar);
Vue.use(Dropdown);
Vue.use(DropdownItem);
Vue.use(DropdownMenu);
Vue.use(Loading)
// 全局挂载Message
Vue.prototype.$message = Message;
Vue.prototype.$alert = MessageBox;
